export default __webpack_public_path__ + "8f5aa428c8b99cb52c1a4f056f3f4b47.png";